/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';
import {
  Paper,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import useStyle from './useStyle';
import FeaturesFlagTable from './components/DataTable/FeaturesFlagTable';
import newButton from '../../assets/img/iconos/newButton.svg';
import searchIcon from '../../assets/img/iconos/searchIcon.svg';
import ActionForm from './components/ActionForm/ActionForm';
import {
  getFeaturesFlagCommerceService,
} from '@/services';
import { Toaster } from '@/components';

// import { COMMERCE_WEB_FEATURES_FLAG } from '../../navigation/privateRoutes';
const COMMERCE_WEB_FEATURES_FLAG = 'commerce-web-features-flag'

const CommerceFeaturesFlagScreen = () => {
  const classes = useStyle();
  const [featuresFlag, setFeaturesFlag] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [enteredFilter, setEnteredFilter] = useState('');
  const defaultData = {
    name: '',
    code: '',
    description: '',
    url: '',
  };
  const [defaultValues, setDefaultValues] = useState(defaultData);
  const [popUpAction, setPopUpAction] = useState({ open: false, title: '', data: null });
  const isCommerceWeb = window.location.pathname.includes(COMMERCE_WEB_FEATURES_FLAG);

  const getFeaturesFlag = async () => {
    try {
      const res = await getFeaturesFlagCommerceService();
      setFeaturesFlag(isCommerceWeb ? res?.data.filter((item) => item?.code.includes('WEB_')) : res?.data.filter((item) => !item?.code.includes('WEB_')));
    } catch (error) {
      setShowAlert(true);
    }
  };

  const createFeaturesFlag = () => {
    setDefaultValues(defaultData);
    setPopUpAction({
      open: true,
      title: 'Crear Feature Flag',
      data: null,
    });
  };

  useEffect(() => {
    getFeaturesFlag();
  }, [isCommerceWeb]);

  return (

    <Paper className={classes.paper}>
      <>
        <div className={classes.root}>
          <div>
            <TextField
              className={classes.searchTextField}
              value={enteredFilter}
              onChange={(e) => setEnteredFilter(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} alt="searchIcon" style={{ paddingLeft: '10px' }} />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              placeholder="Buscar"
            />
            <Tooltip title="Crear Feature Flag" aria-label="Nuevo Feature Flag">
              <IconButton
                onClick={createFeaturesFlag}
                style={{ fontSize: '20px', float: 'right' }}
                edge="end"
                size="small"
                classes={{ disabled: classes.disabled }}
              >
                <img src={newButton} alt="newButton" />
              </IconButton>
            </Tooltip>
          </div>
          <FeaturesFlagTable
            setFeaturesFlag={setFeaturesFlag}
            featuresFlag={featuresFlag}
            setDefaultValues={setDefaultValues}
            enteredFilter={enteredFilter}
            setPopUpAction={setPopUpAction}
          />
          <ActionForm
            open={popUpAction.open}
            data={popUpAction.data}
            title={popUpAction.title}
            defaultValues={defaultValues}
            getFeaturesFlag={getFeaturesFlag}
            onClose={() => {
              setPopUpAction({ open: false, title: '', data: null });
            }}
          />
        </div>
      </>
      <Toaster
        show={showAlert}
        type="error"
        text="Ha ocurrido un error, intente nuevamente."
        onClose={() => setShowAlert(false)}
      />
    </Paper>
  );
};

export default CommerceFeaturesFlagScreen;
